// src/components/checkout/NotesSection.jsx
import React from "react";
import { ChevronIcon } from "../../styles/icons";
import useCheckoutStore from "../../store/useCheckoutStore";

const NotesSection = ({ notes, notesOpen, setNotesOpen }) => {
  const { updateCheckoutData } = useCheckoutStore();

  return (
    <div className="card">
      <h2
        onClick={() => setNotesOpen(!notesOpen)}
        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        Dodatkowe uwagi
        <ChevronIcon
          style={{
            transform: notesOpen ? "rotate(180deg)" : "none",
            marginLeft: "0.5rem",
          }}
        />
      </h2>
      {notesOpen && (
        <textarea
          placeholder="Uwagi do zamówienia (np. bez cebuli, domofon nie działa)"
          value={notes}
          onChange={(e) => updateCheckoutData({ notes: e.target.value })}
          rows={4}
          style={{ marginTop: "1rem", width: "100%" }}
        />
      )}
    </div>
  );
};

export default NotesSection;